import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';

export class Arbeitsbereich {
  constructor({
    markierung,
    name,
    id,
    standortId,
  }: {
    markierung: Markierung;
    standortId: string;
    name: string;
    id: string;
  }) {
    this.markierung = markierung;
    this.name = name;
    this.id = id;
    this.standortId = standortId;
  }

  id: string;
  standortId: string;
  markierung: Markierung;
  name: string;

  getFillColor(): string {
    return getColorsForMarkierung(this.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.markierung).base;
  }
}
